

import { processDataArrayBucketKeysReplacement } from './processDataArrayBucketKeysReplacement';
import { processDataBucketKeysReplacement } from './processDataBucketKeysReplacement';

export const replaceBucketKeys = async (options) => {
  const { data } = options;

  const isArray = Array.isArray(data);

  if (isArray) {
    return processDataArrayBucketKeysReplacement(options);
  }

  return processDataBucketKeysReplacement(options);
};